import { render, staticRenderFns } from "./RequirementValueChangeComment.vue?vue&type=template&id=01f78677&scoped=true"
import script from "./RequirementValueChangeComment.vue?vue&type=script&lang=ts"
export * from "./RequirementValueChangeComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f78677",
  null
  
)

export default component.exports